export default {
  title: 'Opdater afleveringstidspunkt',
  labels: {
    dropoff_time: 'Afleveringstidspunkt',
    confirmed: 'Bekræftet tidspunkt:',
    new_time: 'Nyt tidspunkt:',
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    success: 'Afleveringstidspunktet er opdateret',
    failed_to_save: 'Ændringerne kunne ikke gemmes',
  },
  alerts: {
    dropoff_time_info: 'Både nuværende og nyt tidspunkt er i {{restaurantName}}s tidszone {{timezone}}',
  },
};
